import SiteSpectrumBackgroundStyles from "components/Layout/Sidebar/HeaderBgBlue";
import VideoLogIn from "../Login/components/VideoLogIn";
import React from "react";

interface LayoutVideoAuroraProps {
  readonly children: React.ReactNode;
  readonly renderVideo?: boolean;
}

export default function LayoutVideoAurora(props: LayoutVideoAuroraProps) {
  const { renderVideo = true } = props;
  return (
    <div className="relative grid h-screen min-h-dvh w-full items-start overflow-hidden bg-white dark:bg-gray-900">
      <SiteSpectrumBackgroundStyles />
      <div className="site-spectrum-scroll relative z-[1] mx-auto grid h-full w-full max-w-max-size-grid items-center overflow-y-auto px-4 pb-16 align-middle">
        <div
          className={`grid h-auto w-full grid-cols-1 gap-10 align-middle ${renderVideo ? "md:grid-cols-2" : ""} `}
        >
          {/* Left column (VideoLogIn) */}
          {renderVideo && (
            <div className="relative hidden h-full w-full items-center overflow-hidden md:grid">
              <div className="sticky top-6 flex h-min">
                <VideoLogIn />
              </div>
            </div>
          )}

          {/* Right column with content */}

          <div className="z-5 grid h-auto w-full">{props.children}</div>
        </div>
      </div>

      {/* Footer section with language selector, theme selector, and copyright */}
      <div className="absolute bottom-0 w-full px-4 pb-4">
        <div className="flex items-center justify-center gap-4 text-xs text-gray-400 dark:text-gray-500">
          {/* Center - Copyright */}
          <div className="font-medium">
            Groowcity {new Date().getFullYear()}
          </div>
        </div>
      </div>
    </div>
  );
}
